import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type PositionsDrawerRfqTab = "all" | "options" | "perps";

export const positionsDrawerRfqTabAtom = atomWithStorage<PositionsDrawerRfqTab>(
  "positionsDrawerRfqTab",
  "all",
);

export const usePositionsDrawerRfqTab = () => {
  const [positionsDrawerRfqTab, setPositionsDrawerRfqTab] = useAtom(
    positionsDrawerRfqTabAtom,
  );

  return {
    positionsDrawerRfqTab,
    setPositionsDrawerRfqTab,
  };
};
